export default __webpack_public_path__ + "static/media/dollar_icon.89ff5260.svg";